import script from "./Model3D.vue?vue&type=script&setup=true&lang=ts"
export * from "./Model3D.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__